import React, { useEffect, useState, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useGlobalContext } from "../Config";
import { InputText } from 'primereact/inputtext';
import FormEditarPlantilla from "./FormEditarPlantilla";


function TablePlantillas({
    isFormVisibleEditPlantilla, 
    setIsFormVisibleEditPlantilla,
    // toast prop is ignored in favor of local toast to ensure visibility
}) {
    const { urlContratos } = useGlobalContext();
    const toast = useRef(null);
    const [plantillas, setPlantillas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showEditDialogPlantilla, setShowEditDialogPlantilla] = useState(false);
    const [selectedPlantilla, setSelectedPlantilla] = useState(null);
    const textEditor = (options) => (
        <InputText
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
        />
    );

    const onCellEditComplete = async (e) => {
        const { rowData, field } = e;
        const newValue = e.newValue !== undefined ? e.newValue : e.value;
        if (!rowData?.id) return;
        if (field !== 'nombre' && field !== 'tipo_mime') return;

        const updatedNombre = field === 'nombre' ? newValue : rowData.nombre;
        const updatedTipoMime = field === 'tipo_mime' ? newValue : rowData.tipo_mime;
        const idUsuario = sessionStorage.getItem('usuario_id') || '';

        try {
            const url = `${urlContratos}editarPlantillaDocumento` +
                `?id=${encodeURIComponent(rowData.id)}` +
                `&nombre=${encodeURIComponent(updatedNombre)}` +
                `&tipoMime=${encodeURIComponent(updatedTipoMime)}` +
                `&idAdjunto=${encodeURIComponent(rowData.idAdjunto || '')}` +
                `&idTipoDocumento=${encodeURIComponent(rowData.idTipoDocumento || '')}` +
                `&idUsuario=${encodeURIComponent(idUsuario)}`;

            const resp = await fetch(url, {
                method: 'PUT',
                credentials: 'include',
            });
            if (!resp.ok) throw new Error(`Error al editar plantilla (${resp.status})`);

            setPlantillas(prev =>
                prev.map(p => (p.id === rowData.id ? { ...p, nombre: updatedNombre, tipo_mime: updatedTipoMime } : p))
            );
            toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Plantilla actualizada correctamente', life: 3000 });
        } catch (err) {
            console.error('No se pudo editar la plantilla:', err);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo actualizar la plantilla', life: 3000 });
        }
    };

    useEffect(() => {
        if (!isFormVisibleEditPlantilla) return;
        const fetchPlantillas = async () => {
            try {
                setLoading(true);
                const resp = await fetch(`${urlContratos}getPlantillasDocumentoByEmpresa`, {
                    method: 'GET',
                    credentials: 'include',
                });
                const data = await resp.json();
                const lista = Array.isArray(data.plantillasDocumentos)
                    ? data.plantillasDocumentos
                    : Object.values(data.plantillasDocumentos || {});
                setPlantillas(lista);
            } catch (err) {
                console.error("Error al obtener plantillas de documento:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchPlantillas();
    }, [isFormVisibleEditPlantilla, urlContratos]);

    const deletePlantilla = async (rowData) => {
        try {
            if (!rowData?.id) return;
            const idUsuario = sessionStorage.getItem('usuario_id') || '';
            const resp = await fetch(`${urlContratos}cambiarEstadoPlantillaDocumento?idPlantilla=${rowData.id}&activo=0&idUsuario=${idUsuario}`, {
                method: 'PUT',
                credentials: 'include',
            });
            if (!resp.ok) {
                throw new Error(`Error al eliminar plantilla (${resp.status})`);
            }
            setPlantillas(prev =>
                prev.map(p => (p.id === rowData.id ? { ...p, activo: false } : p))
            );
            toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Plantilla eliminada', life: 3000 });
        } catch (err) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar la plantilla ya que debe haber una por tipo de documento', life: 3000 });
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                header="Editar Plantilla"
                visible={isFormVisibleEditPlantilla}
                onHide={() => setIsFormVisibleEditPlantilla(false)}
                className="p-fluid product-dialog"
            >
                <DataTable 
                    className="p-datatable-gridlines"
                    showGridlines
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} plantillas"
                    dataKey="id"
                    emptyMessage="No se encontraron plantillas."
                    stripedRows="true"
                    globalFilterFields={["nombre"]}
                    scrollHeight="57vh"
                    scrollable
                    value={plantillas}
                    loading={loading}
                    editMode="cell"
                    onCellEditComplete={onCellEditComplete}
                >
                    <Column
                        field="nombre"
                        header="Nombre"
                        sortable
                    />

                    <Column
                        field="nombre_empresa"
                        header="Empresa"
                        sortable
                    />

                    <Column
                        field="nombre_tipo"
                        header="Tipo"
                        sortable
                    />

                    <Column
                        field="activo"
                        header="Estados"
                        body={(rowData) => (
                        <>
                            <div>
                                {rowData.activo ? (
                                <Button
                                    icon="pi pi-check"
                                    className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                                    outlined
                                    tooltip="plantilla activa"
                                    tooltipOptions={{ position: 'top' }}
                                />
                                ) : (
                                <Button
                                    icon="pi pi-times"
                                    className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
                                    onClick={() => {}}
                                    outlined
                                    tooltip="plantilla inactiva"
                                    tooltipOptions={{ position: 'top' }}
                                />
                                )}
                            </div>
                        </>
                        )}
                        sortable
                    />
                    <Column
                        header="Acciones"
                        body={(rowData) => (
                        <>
                            <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                                onClick={() => {
                                    setSelectedPlantilla(rowData);
                                    setShowEditDialogPlantilla(true);
                                }}
                                outlined
                                disabled={!rowData.activo}
                            />
                            <Button
                                icon="pi pi-times"
                                className="p-button-rounded p-button-danger p-button-outlined p-button mr-2 mb-2 mt-2"
                                tooltip="Eliminar Plantilla"
                                tooltipOptions={{ position: 'top' }}
                                onClick={() => deletePlantilla(rowData)}
                                disabled={!rowData.activo}
                            />
                        </>
                        )}
                    />
                </DataTable>

                <FormEditarPlantilla
                    visible={showEditDialogPlantilla}
                    onHide={() => setShowEditDialogPlantilla(false)}
                    plantilla={selectedPlantilla}
                    onSaved={(updated) => {
                        setPlantillas(prev =>
                            prev.map(p => (p.id === updated.id ? { ...p, ...updated } : p))
                        );
                        setShowEditDialogPlantilla(false);
                    }}
                />
            </Dialog>
        </>
    );
}

export default TablePlantillas;
